import React, { useState } from 'react';
import './Management.css';
import './Management3.css';

const LeadsOrders = () => {
    const [showDetails, setShowDetails] = useState({});

    const isMobile = window.innerWidth < 768;

    // =================== Static Data =====================
    const orders = [
        {
            orderId: 'ORD001',
            orderType: 'ONLINE',
            order: [
                { dishName: 'Dosa', quantity: '4', price: 100, status: 'Okay' },
                { dishName: 'Idly', quantity: '5', price: 150, status: 'Okay' },
            ],
            orderDateAndTime: '2025-09-18T11:15:00',
            status: 'BEING_PREPARED',
            service: 'Booking',
        },
        {
            orderId: 'ORD002',
            orderType: 'ONLINE',
            order: [
                { dishName: 'Dosa', quantity: '4', price: 100, status: 'Okay' },
                { dishName: 'Idly', quantity: '5', price: 150, status: 'Okay' },
            ],
            orderDateAndTime: '2025-09-18T11:15:00',
            status: 'BEING_PREPARED',
            service: 'Bookings',
        },
    ];

    const orderStages = ["Order Placed", "Order Completed"];

    const styles = {
        card: {
            border: '1px solid #ccc',
            padding: '16px',
            margin: '16px',
            borderRadius: '10px',
            background: "linear-gradient(to right, #f46b45, #eea849)"
        },
        header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
        orderId: { margin: 0, fontWeight: "bold" },
        date: { fontSize: '18px', color: '#000', fontWeight: "bold" },
        pickupBtn: {
            background: '#28a745',
            color: '#fff',
            border: 'none',
            padding: '6px 12px',
            cursor: 'pointer',
            borderRadius: '5px',
            fontWeight: "bold"
        },
        tracker: {
            marginTop: '10px',
            display: 'flex',
            alignItems: 'center',
            fontWeight: "bold"
        },
        statusBox: {
            background: '#eee',
            padding: '8px 12px',
            borderRadius: '5px',
            transition: "0.3s",
            textTransform: "uppercase"
        },
        arrow: { margin: '0 5px' },
        dropdownBtn: { background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer' },
    };

    return (
        <div className="container-fluid">
            <div className="row">
                <div>
                    {orders.map((order) => {
                        const orderItems = order.orderType === "TABLE_DINE_IN" ? order.cartItems || [] : order.order || [];
                        const orderId = order.orderId || order.cartId;

                        return (
                            <div key={orderId} style={styles.card}>
                                <div style={styles.header}>
                                    <h3 style={styles.orderId}>Order ID: {orderId}</h3>
                                    <button style={styles.pickupBtn}>{order.service || order.orderType || 'Service'}</button>
                                    <button
                                        style={styles.dropdownBtn}
                                        onClick={() =>
                                            setShowDetails((prev) => ({
                                                ...prev,
                                                [orderId]: !prev[orderId],
                                            }))
                                        }
                                    >
                                        {showDetails[orderId] ? '▲' : '▼'}
                                    </button>
                                </div>

                                {showDetails[orderId] && (
                                    <>
                                        <p style={styles.date}>
                                            {order.orderDateAndTime ? (() => {
                                                const dateObj = new Date(order.orderDateAndTime);
                                                const date = dateObj.toLocaleDateString('en-IN', {
                                                    day: '2-digit',
                                                    month: '2-digit',
                                                    year: 'numeric',
                                                });
                                                const time = dateObj.toLocaleTimeString('en-IN', {
                                                    hour: '2-digit',
                                                    minute: '2-digit',
                                                    hour12: true,
                                                });
                                                return (
                                                    <>
                                                        <span style={{ color: 'black' }}>Date: </span>
                                                        <span style={{ color: 'white' }}>{date}</span>
                                                        <br />
                                                        <span style={{ color: 'black' }}>Time: </span>
                                                        <span style={{ color: 'white' }}>{time}</span>
                                                    </>
                                                );
                                            })() : 'N/A'}
                                        </p>

                                        <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '1rem' }}>
                                            <thead>
                                                <tr style={{ backgroundColor: '#b15cd6', textAlign: 'center' }}>
                                                    <th style={{ padding: '8px', border: '1px solid #ddd' }}>S.No</th>
                                                    <th style={{ padding: '8px', border: '1px solid #ddd' }}>Dish Name </th>
                                                    <th style={{ padding: '8px', border: '1px solid #ddd' }}>Quantiy</th>
                                                    <th style={{ padding: '8px', border: '1px solid #ddd' }}>Price</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {orderItems.map((item, index) =>
                                                    item.status === "Okay" || item.orderType === "TABLE_DINE_IN" ? (
                                                        <tr key={index} style={{ borderBottom: '1px solid #eee', fontWeight: 'bold', backgroundColor: '#d4edda' }}>
                                                            <td style={{ padding: '8px', border: '1px solid #ddd' }}>{index + 1}</td>
                                                            <td style={{ padding: '8px', border: '1px solid #ddd' }}>{item.dishName}</td>
                                                            <td style={{ padding: '8px', border: '1px solid #ddd' }}>{item.quantity || 1}</td>
                                                            <td style={{ padding: '8px', border: '1px solid #ddd' }}>{item.price}</td>
                                                        </tr>
                                                    ) : null
                                                )}
                                            </tbody>
                                        </table>
                                    </>
                                )}

                                {/* ===== Tracker ===== */}
                                <div style={{
                                    ...styles.tracker,
                                    justifyContent: 'center',
                                    flexDirection: isMobile ? 'column' : 'row',
                                    gap: isMobile ? '5px' : '0px'
                                }}>
                                    {orderStages.map((stage, index) => {
                                        const statusToStage = {
                                            PROCESSING: "Order Placed",
                                            BEING_PREPARED: "Captain Accepted",
                                            ORDER_IS_READY: "Captain on the way",
                                            WAITING_FOR_PICKUP: "Captain Reached location",
                                            COMPLETED: "Ride Completed",
                                        };

                                        let isActive = false;
                                        if (order.orderType === "TABLE_DINE_IN" && Array.isArray(order.cartItems)) {
                                            const relevantStatuses = ["PROCESSING", "BEING_PREPARED", "ORDER_IS_READY", "WAITING_FOR_PICKUP"];
                                            const itemStageIndexes = order.cartItems
                                                .filter(item => relevantStatuses.includes(item.orderStatus))
                                                .map(item => orderStages.indexOf(statusToStage[item.orderStatus] || "Order Placed"))
                                                .filter(i => i !== -1);
                                            const highestStageIndex = itemStageIndexes.length > 0 ? Math.max(...itemStageIndexes) : 0;
                                            isActive = index <= highestStageIndex;
                                        } else {
                                            const currentStageIndex = orderStages.indexOf(statusToStage[order.status] || "Order Placed");
                                            isActive = index <= currentStageIndex;
                                        }

                                        // 🎯 Highlight "Order Placed" stage
                                        const isOrderPlaced = stage === "Order Placed";
                                        const boxStyle = {
                                            ...styles.statusBox,
                                            backgroundColor: isOrderPlaced ? "rgb(160 85 176)" : (isActive ? "green" : "#f0f0f0"),
                                            color: isOrderPlaced ? "black" : (isActive ? "white" : "black"),
                                            // border: isOrderPlaced ? "2px solid #FFA500" : "none",
                                            // boxShadow: isOrderPlaced ? "0px 0px 10px #FFD700" : "none"
                                        };

                                        return (
                                            <React.Fragment key={index}>
                                                <div style={boxStyle}>{stage}</div>
                                                {index !== orderStages.length - 1 && <span style={styles.arrow}></span>}
                                            </React.Fragment>
                                        );
                                    })}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default LeadsOrders;
